import { SocialAuthService, SocialUser } from '@abacritt/angularx-social-login';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Animation, AnimationController } from '@ionic/angular';
import { ReplaySubject, takeUntil } from 'rxjs';

declare const google: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('logo', { read: ElementRef }) logo: ElementRef;
  @ViewChild('title', { read: ElementRef }) title: ElementRef;
  @ViewChild('button', { read: ElementRef }) button: ElementRef;

  logoWidth = 145;
  logoHeight = 40;
  user: SocialUser;
  loggedIn: boolean;
  private animation: Animation = null;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(
    private router: Router,
    private authService: SocialAuthService,
    private animationCtrl: AnimationController
  ) {}

  ngOnInit(): void {
    this.authService.authState
      .pipe(takeUntil(this.destroyed$))
      .subscribe((user) => {
        this.user = user;
        this.loggedIn = user != null;
        this.router.navigate(['']);
        console.log({ user });
      });
  }

  ngAfterViewInit(): void {
    this.renderSocialGoogleButton();
    const logoOffsetX = window.innerWidth / 2 - this.logoWidth / 2 - 12;
    const logoOffsetY =
      window.innerHeight / 2 -
      this.logoHeight / 2 -
      (window.innerHeight * 0.55 - 160);

    const logoAnimation = this.animationCtrl
      .create()
      .addElement(this.logo.nativeElement)
      .keyframes([
        {
          offset: 0,
          transform: `translateX(${logoOffsetX}px) translateY(${logoOffsetY}px) scale(1)`,
        },
        { offset: 1, transform: `translateX(0) translateY(0) scale(.5)` },
      ]);

    const opacityAnimation = this.animationCtrl
      .create()
      .addElement(this.button.nativeElement)
      .addElement(this.title.nativeElement)
      .beforeStyles({
        opacity: '0',
      })
      .keyframes([
        { offset: 0.5, opacity: '0' },
        { offset: 1, opacity: '1' },
      ]);

    this.animation = this.animationCtrl
      .create()
      .delay(1250)
      .duration(500)
      .easing('ease-in-out')
      .addAnimation([logoAnimation, opacityAnimation]);

    this.animation.play();
  }

  renderSocialGoogleButton() {
    google.accounts.id.renderButton(
      document.getElementById('google_button'),
      { theme: 'outline', size: 'large' } // customization attributes
    );
    google.accounts.id.prompt();
  }

  ngOnDestroy(): void {
    this.animation?.destroy();
  }
}
